import React from "react";
import Project from "../components/Project";

function Projects() {
  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./projects/Projects_header.png"
        alt="Projects"
        className="header-img"
      />

      {/* Projects */}
      <Project
        shortProjectName="SimSnap"
        projectNameColor="#ff6600"
        projectName="An Interactive Cross-Device Shared-Display Platform"
        image="./projects/SimSnap.jpg"
        description="SimSnap is a multi-device shared-display platform that facilitates cross-device 
        interaction to perform collaborative group activities. Multiple users can join or “Snap” their 
        touchscreen devices (e.g., smartphones or tablets) together to perform different types of 
        collaborative tasks, for example, classroom learning, playing games, photo sharing, and many 
        more. While being snapped, users can join their screens and form a larger shared display, 
        combining their own devices with other snapped users. In a shared display mode, users can mirror 
        their screens, expand their screens, and move components between their screens. Users can “unsnap” 
        their devices and can go back to work individually. In the course project, students will design 
        cross-device interactions, games, or other applications. They will create low- and high-fidelity 
        prototypes of their work and will evaluate their design with a usability analysis study."
        projectLink="https://drive.google.com/drive/u/0/folders/1MG8eE2Wr8KmVe8I2UgpNH8uMSc2v5b60?usp=sharing"
        readingsLink="https://drive.google.com/drive/u/0/folders/1vJipoFndMwe1YONDo4kw16yDVpxItl64?usp=sharing"
      />

      <Project
        shortProjectName="MEMO"
        projectNameColor="#3399ff"
        projectName="Tangible Multi-Surface Interactions for Exploring Migration Data"
        image="./projects/MEMO.jpg"
        description="MEMO is a multidisciplinary research partnership that draws on data to investigate 
        migration patterns originating in countries from three intercontinental regions in fourteen 
        countries with different cultures and languages. By uncovering new connections between macro-level, 
        contextual drivers (such as economic or political conditions) and individual determinants (such as 
          the cultural and emotional factors that influence a migrant’s personal decisions), the project 
        aims to uncover new knowledge and develop a framework for a better understanding of migration. In 
        the long term, the project aims to create innovative analytical tools and frameworks to aid decision 
        makers in developing future migration policies. This semester, students will design and prototype a 
        tangible and tabletop/wall based interface that allows exploratory visualization and interaction 
        with migration data and models from West Africa."
        projectLink="https://drive.google.com/drive/u/0/folders/1r3pwDdmgzuc18tWf0kb6lD-DReo5WRZ8?usp=sharing"
        readingsLink="https://drive.google.com/drive/u/0/folders/1LM11VXoExSS34GQYb4L0neU5AOuF3IZi?usp=sharing"
      />

      <Project
        shortProjectName="ADAPT"
        projectNameColor="#009933"
        projectName="Advanced Dynamic Audio-Visual Playback Technology"
        image="./projects/ADAPT.png"
        description="This research project focuses on the development and prototyping of advanced interfaces 
        for variable speed media playback, aiming to improve user experience and efficiency in engaging with 
          linear digital media. The project is structured into three main phases: (1) Investigating current 
        challenges and user needs in speed-adjustable media interfaces, (2) Creating user-friendly and adaptable 
        tangible interface designs that accommodate various user preferences and situations, and (3) Testing and 
        refining these prototypes in practical settings. By incorporating technologies like machine learning, 
        the project seeks to intelligently suggest optimal playback speeds based on the type of content and 
        individual user patterns. The anticipated outcomes include more personalized, context-sensitive, and 
        efficient ways for users to interact with media. This research is poised to make a meaningful impact 
        on the digital media landscape, benefiting content creators, distributors, and consumers by enhancing 
        the overall media consumption experience."
        projectLink="https://drive.google.com/drive/u/0/folders/13RCQXUaWPCuEGH8gVSvVn029ZUFdtBhk?usp=sharing"
        readingsLink="https://drive.google.com/drive/u/0/folders/1aRLCNssqZz6K3cl4iCOw5OqnqdMxhA2e?usp=sharing"
      />

      <Project
        shortProjectName="MRGeM"
        projectNameColor="#9966ff"
        projectName="Mixed Reality for Genetic Mutation Data Exploration"
        image="./projects/MRGeM.jpg"
        description="MRGeM is an innovative prototype developed within Unreal Engine, leveraging interactive 
        visualization within a head-mounted mixed reality (MR) environment. Its primary purpose is to facilitate 
        the exploration of genetic mutation patterns and their impact on affected organs in cases of cancer. The 
        system's objective revolves around enhancing existing workflows through immersive data analytics. 
        Analysts can dissect individual organs of a 3D human avatar and access 2D genetic mutation data 
        represented in room-scale cylindrical formats. Furthermore, identified patterns can be reflected back 
        onto the avatar. Notably, ongoing challenges encompass devising interactive methods for efficient data 
        searching and filtering. The immediate semester goals involve devising tangible or mobile interaction 
        methods for filtering, sorting, clustering, and searching through the dataset within the MR environment, 
        employing machine learning modules to achieve these objectives."
        projectLink="https://drive.google.com/drive/u/0/folders/1P2N3zhrAmfvvl1RmM1ElS8G155wQ9EK5?usp=sharing"
        readingsLink="https://drive.google.com/drive/u/0/folders/14t2a-VPouZM8EQQNBHrzqQYmlTbXx_0C?usp=sharing"
      />

    </div>
  );
}

export default Projects;
